module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-menu-img-2-2aaaae6c4cc5ea87c31de5448c1d9da6.png";